import React from "react";
import emptyCar from '../../media/images/emptyFavorites.png';
import classes from './EmptyContentCard.module.scss';

const EmptyContentCard = ({header , message}) => {
    header = header || "You don’t have any favorites yet." 
    message = message || "Explore our assets and mark the ones you like the most, so you don’t lose sight of them."
    return (
        <div className={classes.FavoriteEmptyCars}>
                <img src={emptyCar} alt="empty"/>
                <div className={classes.FavoriteEmptyCarsText}>
                            <h3>{header}</h3>
                            <p>{message}</p>
                </div>
         </div>
    )
}

export default EmptyContentCard;